/*
 * @Author: 刘小博
 * @Date: 2023-02-17 11:32:51
 * @LastEditTime: 2023-04-14 17:20:17
 * @LastEditors: 刘小博
 * @Description:
 * @FilePath: \p2ps_vip_web\src\router\mg\system-settings\modules\systemSettingRouter.js
 * 系统配置
 */
const systemSettingRouter = [
  // 芒哥 系统设置
  {
    path: '/mg/system-set',
    name: 'MgSystemSet',
    component: () =>
      import(
        /*webpackChunkName:"mg" */
        // '@/views/mg/systemSettings.vue'
        '@/views/mg/system-settings/system-config/Page.vue'
      ),
    meta: {
      SecondaryMenu: '系统配置', //二级菜单
      title: '系统设置',
    },
  },
  // 芒哥 综合服务商操作设置
  {
    path: '/mg/service-operation-set',
    name: 'MgServiceOperationSet',
    component: () =>
      import(
        /*webpackChunkName:"mg" */
        // '@/views/mg/ServiceOperationSet.vue'
        '@/views/mg/system-settings/system-config/service-operation/Page.vue'
      ),
    meta: {
      SecondaryMenu: '系统配置', //二级菜单
      title: '综合服务商操作设置',
      breadcrumb: [
        {
          title: '系统设置',
          name: 'MgSystemSet',
        },
      ],
    },
  },
  // 芒哥 操作日志
  {
    path: '/mg/operation-log/:meta_type',
    name: 'MgOperationLog',
    component: () => import(
      // '@/views/mg/OperationLog.vue'
      '@/views/mg/system-settings/operation-log/Page.vue'
      ),
    meta: {
      SecondaryMenu: '系统配置', //二级菜单
      title: '操作日志',
    },
  },
]

export default systemSettingRouter
